import { useQuery } from '@apollo/client';

import { FetchAddress } from '../api/queries/address.gql';

export function useAddress({ postalCode, houseNumber, houseNumberAddition }) {
  const { data } = useQuery(FetchAddress, {
    variables: {
      postalCode,
      houseNumber,
      houseNumberAddition,
    },
    skip: houseNumber === '' || postalCode === '',
    fetchPolicy: 'cache-first',
  });

  if (houseNumber === '' || postalCode === '' || data?.address === undefined) {
    return { street: '', city: '', message: '' };
  }

  return {
    street: data.address?.street,
    city: data.address?.city,
    message: data.address?.message,
  };
}
